import { API_URL } from '../../../app-config/constants';
import MeetingMetadataDto from '../../../types/MeetingMetadataDto';
import { get } from '../request';

const BASE_PATH = `${API_URL}/meetings/metadata`;

interface GetMeetingCollectionRequest {
    participants: string[];
    startDate?: string;
    endDate?: string;
    limit?: number;
}

export function getMetadata(q: GetMeetingCollectionRequest) {
    return get<MeetingMetadataDto[]>(BASE_PATH, {
        getData: {
            participants: q.participants.join(','),
            startDate: q.startDate,
            endDate: q.endDate,
            limit: q.limit ? q.limit.toString() : undefined,
        },
    });
}
